import ClientConfigPA from "./docs.pa.clientConfig";

const PatientAccess = () => {
  return (
    <div>
      <h1>Patient Access API</h1>
      <ClientConfigPA />
    </div>
  );
}

export default PatientAccess;